import { useState } from "react";
import { parseIndirizzi } from "../intestazione";

const MOSTRA = 2;

// Riga "A:" / "CC:" / "CCN:" dell'intestazione: indirizzi cliccabili (→ nuova email), "+N altri" espande la lista
export function Destinatari({ etichetta, valore, onScrivi, chiave }) {
  const [aperto, setAperto] = useState(false);
  const tutti = parseIndirizzi(valore);
  if (tutti.length === 0) return null;
  const visibili = aperto ? tutti : tutti.slice(0, MOSTRA);
  const nascosti = tutti.length - visibili.length;
  return (
    <div className="detail-dest" title={valore} data-testid={`detail-dest-${chiave}`}>
      <span className="detail-dest-label">{etichetta}:</span>
      {visibili.map((d, i) => (
        <span key={d.email + i} className="detail-dest-item">
          <button
            type="button"
            className="detail-dest-chip"
            title={d.nome ? `${d.email} — scrivi una nuova email` : "Scrivi una nuova email"}
            onClick={() => onScrivi?.(d.email)}
            data-testid={`detail-dest-${chiave}-${i}`}
          >
            {d.nome || d.email}
          </button>
          {(i < visibili.length - 1 || nascosti > 0) && ","}
        </span>
      ))}
      {nascosti > 0 && (
        <button type="button" className="detail-dest-altri" onClick={() => setAperto(true)} data-testid={`detail-dest-${chiave}-altri`}>
          +{nascosti} {nascosti === 1 ? "altro" : "altri"}
        </button>
      )}
      {aperto && tutti.length > MOSTRA && (
        <button type="button" className="detail-dest-altri" onClick={() => setAperto(false)} data-testid={`detail-dest-${chiave}-meno`}>
          mostra meno
        </button>
      )}
    </div>
  );
}
